import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhyItFailedSection() {
  const failures = ['Las dietas genéricas no entienden que el cerebro femenino de 45+ procesa la energía de forma totalmente distinta tras la caída de estrógenos.', 'El exceso de cafeína agota tus niveles de cortisol, aumentando los bloqueos de memoria bajo estrés.', 'Los suplementos "multivitamínicos" promedio no cruzan la barrera hematoencefálica para alimentar tus neuronas directamente.', 'Esperar a que "el tiempo lo cure" permite que la neuro-inflamación se vuelva el estado normal de tu cerebro.'];
  return <section className="w-full bg-sage text-cream py-20 px-6" data-id="element-173">
      <div className="max-w-3xl mx-auto" data-id="element-174">
        <FadeIn data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center text-cream" data-id="element-176">
            Por qué lo que has intentado hasta ahora NO ha funcionado
          </h2>

          <div className="space-y-6" data-id="element-177">
            {failures.map((text, index) => <div key={index} className="flex items-start gap-4 bg-sage-dark p-6 rounded-xl border border-sage-light" data-id="element-178">
                <div className="flex-shrink-0 w-8 h-8 bg-gold/20 rounded-full flex items-center justify-center mt-1" data-id="element-179">
                  <svg className="w-5 h-5 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-180">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-181" />
                  </svg>
                </div>
                <p className="text-lg leading-relaxed m-0" data-id="element-182">{text}</p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}